import React from 'react';
import moment from 'moment';
import { MenuItemType, MenuRow } from 'components/containers/CollapsableMenu';
import DocumentRow from 'components/rows/DocumentRow';
import { GraphQLLeaseDocumentObjectType } from 'types/documents-types';

export const createLeasesItems = (
  docs: GraphQLLeaseDocumentObjectType[] = []
) => {
  const items: MenuRow[] = [];
  docs.forEach((doc) => {
    const date = moment(doc.dateSigned);
    items.push({
      type: MenuItemType.Row,
      row: (
        <DocumentRow
          id={doc.rentLeaseId}
          title={`Lease ${date.format('YYYY')}`}
          uri={doc.documentUri}
          subtitle={date.format('MMMM DD, YYYY')}
        />
      ),
    });
  });

  return items;
};
